export default __webpack_public_path__ + "static/media/recognition.954af81e.svg";